/**
 * Pagination - Page navigation for admin users list
 */
export default function Pagination({ page, totalPages, setPage }) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        onClick={() => setPage(Math.max(1, page - 1))}
        disabled={page === 1}
        className="px-4 py-2 bg-muted hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed text-foreground rounded-lg transition"
      >
        Previous
      </button>
      <span className="px-4 py-2 text-muted-foreground">
        Page {page} of {totalPages}
      </span>
      <button
        onClick={() => setPage(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="px-4 py-2 bg-muted hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed text-foreground rounded-lg transition"
      >
        Next
      </button>
    </div>
  );
}
